import React from 'react'
import UserTag from '../../UserTag'
import UserTagNoLive from '../../UserTag/UserTagNoLive'
export const cell_user = (mutate, showModal, index?, width?) => {
	return {
		title: '회원',
		dataIndex: index ? index : 'user_id',
		key: 'user_id',
		align: 'center',
		width: width ? width : 150,
		render: (text, data) => {
			return (
				<UserTag
					userid={text}
					email={data?.email}
					phone={data?.phone}
					nickname={data?.fullname || data?.nickname}
					onClick={() => {
						showModal(text)
					}}
				/>
			)
		},
	}
}

export const cell_user_nolive = (mutate, showModal, index?, width?) => {
	return {
		title: '회원',
		dataIndex: index ? index : 'user_id',
		key: 'user_id',
		align: 'center',
		width: width ? width : 150,
		render: (text, data) => {
			return (
				<UserTagNoLive
					userid={text}
					email={data?.email}
					phone={data?.phone}
					nickname={data?.fullname || data?.nickname}
					onClick={() => {
						showModal(text)
					}}
				/>
			)
		},
	}
}
